<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <InvoicesInfoView/>
  </div>
</template>

<script>
import InvoicesInfoView from "./InvoicesInfoView";

export default {
  name: 'InvoicesInfo',
  middleware: 'auth',
  components: {
    InvoicesInfoView
  }
}
</script>
